import _ from "lodash";

const domains = [
  {
    fullName: "Fundamentals of Quality Nursing Care",
    name: "Nursing Care",
    key: "magnet_quality",
  },
  {
    fullName: "Leadership Access and Responsiveness",
    name: "Leadership Access",
    key: "magnet_leadership",
  },
  {
    fullName: "Autonomy",
    name: "Autonomy",
    key: "magnet_autonomy",
  },
  {
    fullName: "Interprofessional Relationships",
    name: "Interprof. Relationships",
    key: "magnet_interprof",
  },
  {
    fullName: "RN-to-RN Teamwork and Collaboration",
    name: "RN-to-RN Teamwork",
    key: "magnet_teamwork",
  },
  {
    fullName: "Professional Development",
    name: "Professional Development",
    key: "magnet_prof_dev",
  },
  {
    fullName: "Adequacy of Resources and Staffing",
    name: "Resources",
    key: "magnet_resources",
  },
];

const domainFullNames = _.map(domains, "fullName");
const domainNames = _.map(domains, "name");
const domainKeys = _.map(domains, "key");

export { domains, domainFullNames, domainNames, domainKeys };



// WEBPACK FOOTER //
// ./src/modules/magnetDomains.js